module.exports = __webpack_public_path__ + "static/shield-1547db58e778d14263cb3e720fade0aa.png";